export function readableDate(date, locales = 'nl-nl', short) {
    if (short) {
        return date
            ? new Date(date).toLocaleDateString(locales, {
                year: 'numeric',
                month: '2-digit',
                day: 'numeric',
            })
            : '-';
    }
    return date
        ? new Date(date).toLocaleDateString(locales, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        })
        : '-';
}
export function readableDateTime(date, locales = 'nl-nl') {
    return date
        ? readableDate(date, locales) +
            (readableDate(date, locales) !== 'Invalid Date'
                ? ' ' +
                    new Date(date).toLocaleTimeString(locales, {
                        hour: 'numeric',
                        minute: 'numeric',
                    })
                : '')
        : '-';
}
